import React from "react";

export default function DisclaimerPopup({ onAccept }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-[90%] max-w-md p-6 rounded-lg shadow-lg text-center">

        <h2 className="text-xl font-bold mb-3 text-red-600">
          Disclaimer & Terms
        </h2>

        <p className="text-sm text-gray-700 leading-relaxed">
          This calculator uses government published data and logic-based estimation.
          <br /><br />
          <b>Please verify all rates and calculations manually from official circulars before making any decisions.</b>
          <br /><br />
          By continuing, you agree that We are not legally responsible for financial decisions based solely on this system.
        </p>

        <button
          className="mt-5 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          onClick={onAccept}
        >
          I Agree & Continue
        </button>
      </div>
    </div>
  );
}
